export default __webpack_public_path__ + "static/media/Strangler's Gloves of Shattered Souls.0e15c90e.jpg";